// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CanvasEditor 样式 */
.CanvasEditor-container {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: #d8d6ce;
}

.CanvasEditor-toolbar {
  min-height: 58px;
  background: #11120f;
  border-bottom: 1px solid #35382f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 1000;
}

.CanvasEditor-toolbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.CanvasEditor-back-button {
  padding: 0.5rem 1rem;
  color: #d9dccf;
  background: transparent;
  border: 1px solid #45483f;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.CanvasEditor-back-button:hover {
  color: #11120f;
  background: #d8ff45;
  border-color: #d8ff45;
}

.CanvasEditor-title-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.CanvasEditor-title {
  margin: 0;
  font-size: 1.1rem;
  color: #f2efe6;
  font-family: Georgia, 'Songti SC', serif;
  font-weight: 400;
}

.CanvasEditor-title-input {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  padding: 0.25rem 0.5rem;
  border: 2px solid #667eea;
  border-radius: 4px;
  outline: none;
  min-width: 200px;
}

.CanvasEditor-edit-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: #666;
  transition: color 0.2s;
  font-size: 16px;
}

.CanvasEditor-edit-button:hover {
  color: #667eea;
}

.CanvasEditor-toolbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.CanvasEditor-saving {
  color: #999;
  font-size: 0.9rem;
}

.CanvasEditor-save-button {
  padding: 0.5rem 1rem;
  background: #d8ff45;
  color: #11120f;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.CanvasEditor-save-button:hover {
  background: #e5ff80;
}

.CanvasEditor-save-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.CanvasEditor-share-button {
  padding: 0.5rem;
  background: transparent;
  color: #94a3b8;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}

.CanvasEditor-share-button:hover {
  background: rgba(148, 163, 184, 0.1);
  color: #64748b;
}

.CanvasEditor-export-button {
  padding: 0.5rem;
  background: transparent;
  color: #94a3b8;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  position: relative;
}

.CanvasEditor-export-button:hover {
  background: rgba(148, 163, 184, 0.1);
  color: #64748b;
}

.CanvasEditor-export-button:disabled {
  cursor: not-allowed;
  color: #cbd5f5;
  background: rgba(148, 163, 184, 0.12);
}

.CanvasEditor-export-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(148, 163, 184, 0.4);
  border-top-color: #64748b;
  border-radius: 50%;
  animation: CanvasEditor-spin 0.8s linear infinite;
}

.CanvasEditor-exporting {
  color: #666;
  font-size: 0.9rem;
}

.CanvasEditor-export-button:disabled .CanvasEditor-export-spinner {
  border-top-color: #94a3b8;
}

.CanvasEditor-login-button {
  padding: 0.5rem 1.5rem;
  background: #d8ff45;
  color: #11120f;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
}

.CanvasEditor-login-button:hover {
  background: #e5ff80;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  transform: translateY(-1px);
}

.CanvasEditor-canvas {
  flex: 1;
  position: relative;
  overflow: hidden;
  min-height: 0;
}

.CanvasEditor-loading,
.CanvasEditor-error {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  gap: 1rem;
}

.CanvasEditor-error-message {
  color: #e53e3e;
  font-size: 1.2rem;
}

.CanvasEditor-error-button {
  padding: 0.75rem 1.5rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
}

.CanvasEditor-error-button:hover {
  background: #5568d3;
}

/* 只读徽章 */
.CanvasEditor-readonly-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: #fef3c7;
  color: #92400e;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
}

/* 复制按钮 */
.CanvasEditor-clone-button {
  padding: 0.5rem 1rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.CanvasEditor-clone-button:hover {
  background: #059669;
}

.CanvasEditor-clone-button:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 会员升级弹窗样式 */
.CanvasEditor-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: CanvasEditor-fadeIn 0.2s ease-out;
}

.CanvasEditor-dialog {
  background: white;
  border-radius: 24px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.3);
  max-width: 480px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: CanvasEditor-slideUp 0.3s ease-out;
}

.CanvasEditor-dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.75rem 0;
  text-align: center;
  line-height: 1.3;
}

.CanvasEditor-dialog-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: center;
}

.CanvasEditor-dialog-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.85rem 1.75rem;
  border: none;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.CanvasEditor-dialog-button:hover {
  transform: translateY(-1px);
}

.CanvasEditor-dialog-button-cancel {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.35);
  color: #475569;
}

.CanvasEditor-dialog-button-cancel:hover {
  background: rgba(241, 245, 249, 0.96);
  border-color: rgba(99, 102, 241, 0.45);
}

.CanvasEditor-upgrade-overlay {
  padding: 2rem;
}

.CanvasEditor-upgrade-dialog {
  position: relative;
  overflow: hidden;
  max-width: 540px;
  padding: 3rem 2.75rem 2.5rem;
  text-align: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #ffffff 65%, rgba(245, 247, 250, 0.98) 100%);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.35);
  animation: CanvasEditor-upgrade-pop 280ms ease-out;
}

.CanvasEditor-upgrade-dialog::before,
.CanvasEditor-upgrade-dialog::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(0px);
}

.CanvasEditor-upgrade-dialog::before {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(254, 215, 170, 0.55) 0%, rgba(255, 255, 255, 0) 65%);
  top: -140px;
  right: -120px;
}

.CanvasEditor-upgrade-dialog::after {
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(127, 61, 255, 0.35) 0%, rgba(255, 255, 255, 0) 75%);
  bottom: -110px;
  left: -90px;
}

.CanvasEditor-upgrade-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fed7aa 0%, #f97316 100%);
  color: #9a3412;
  box-shadow: 0 10px 40px rgba(249, 115, 22, 0.25);
  position: relative;
  z-index: 1;
}

.CanvasEditor-upgrade-icon svg {
  width: 36px;
  height: 36px;
}

.CanvasEditor-upgrade-title {
  margin-bottom: 0.75rem;
  position: relative;
  z-index: 1;
}

.CanvasEditor-upgrade-message {
  font-size: 1rem;
  color: #3c4559;
  line-height: 1.65;
  margin: 0 auto 1.85rem auto;
  max-width: 420px;
  padding: 0.75rem 1rem;
  background: rgba(236, 244, 255, 0.65);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  position: relative;
  z-index: 1;
}

.CanvasEditor-upgrade-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 1.75rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: #2d3748;
  font-size: 0.95rem;
  position: relative;
  z-index: 1;
}

.CanvasEditor-upgrade-benefits li {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  text-align: left;
  padding: 0.65rem 0.9rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.65);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.CanvasEditor-upgrade-benefits li::before {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #fcd34d 0%, #f97316 60%, #c026d3 100%);
  flex-shrink: 0;
}

.CanvasEditor-upgrade-actions {
  margin-top: 1rem;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.CanvasEditor-upgrade-button {
  background: linear-gradient(135deg, #7f3dff 0%, #d53f8c 100%);
  color: #ffffff;
  box-shadow: 0 10px 30px rgba(127, 61, 255, 0.35);
  min-width: 150px;
}

.CanvasEditor-upgrade-button:hover {
  background: linear-gradient(135deg, #6b2bd3 0%, #b83280 100%);
  transform: translateY(-1px);
}

.CanvasEditor-upgrade-actions .CanvasEditor-dialog-button-cancel {
  min-width: 120px;
}

/* 动画效果 */
@keyframes CanvasEditor-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes CanvasEditor-slideUp {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes CanvasEditor-upgrade-pop {
  0% {
    opacity: 0;
    transform: translateY(24px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes CanvasEditor-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .CanvasEditor-upgrade-overlay {
    padding: 1.5rem;
  }

  .CanvasEditor-upgrade-dialog {
    padding: 2.5rem 1.5rem 2rem;
  }

  .CanvasEditor-upgrade-message {
    padding: 0.65rem 0.75rem;
  }

  .CanvasEditor-upgrade-benefits li {
    padding: 0.55rem 0.75rem;
  }
}

/* 公开项目提示弹窗 */
.CanvasEditor-public-dialog {
  max-width: 420px;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.CanvasEditor-public-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
}

.CanvasEditor-public-message {
  font-size: 0.95rem;
  color: #475569;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
}

.CanvasEditor-dialog-button-confirm {
  background: #10b981;
  color: white;
}

.CanvasEditor-dialog-button-confirm:hover {
  background: #059669;
}

/* 图片转存提示弹窗 */
.CanvasEditor-transfer-dialog {
  max-width: 500px;
  padding: 2rem 2rem 1.5rem;
  text-align: center;
}

.CanvasEditor-transfer-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #d97706;
}

.CanvasEditor-transfer-message {
  font-size: 0.95rem;
  color: #475569;
  line-height: 1.6;
  margin: 0 0 1.5rem 0;
}

.CanvasEditor-transfer-details {
  margin: 1rem 0 1.5rem 0;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  text-align: left;
}

.CanvasEditor-transfer-tip {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: white;
  border-left: 3px solid #f59e0b;
  border-radius: 4px;
}

.CanvasEditor-transfer-list {
  margin-top: 1rem;
}

.CanvasEditor-transfer-list-title {
  font-weight: 600;
  font-size: 0.875rem;
  color: #334155;
  margin-bottom: 0.5rem;
}

.CanvasEditor-transfer-item {
  font-size: 0.85rem;
  color: #64748b;
  padding: 0.5rem;
  background: white;
  border-radius: 4px;
  margin-bottom: 0.25rem;
}

/* 帮助按钮样式 */
.CanvasEditor-help-button {
  padding: 0.5rem;
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  color: #667eea;
}

.CanvasEditor-help-button:hover {
  background: #f0f4ff;
  border-color: #667eea;
  transform: translateY(-1px);
}

.CanvasEditor-help-button svg {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/canvasEditor/CanvasEditor.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,8GAA8G;EAC9G,0CAA0C;EAC1C,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6FAA6F;EAC7F,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4FAA4F;EAC5F,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qFAAqF;EACrF,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,UAAU;AACV;EACE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* CanvasEditor 样式 */\n.CanvasEditor-container {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  background: #d8d6ce;\n}\n\n.CanvasEditor-toolbar {\n  min-height: 58px;\n  background: #11120f;\n  border-bottom: 1px solid #35382f;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1rem;\n  z-index: 1000;\n}\n\n.CanvasEditor-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.CanvasEditor-back-button {\n  padding: 0.5rem 1rem;\n  color: #d9dccf;\n  background: transparent;\n  border: 1px solid #45483f;\n  border-radius: 999px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n}\n\n.CanvasEditor-back-button:hover {\n  color: #11120f;\n  background: #d8ff45;\n  border-color: #d8ff45;\n}\n\n.CanvasEditor-title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.CanvasEditor-title {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #f2efe6;\n  font-family: Georgia, 'Songti SC', serif;\n  font-weight: 400;\n}\n\n.CanvasEditor-title-input {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #333;\n  padding: 0.25rem 0.5rem;\n  border: 2px solid #667eea;\n  border-radius: 4px;\n  outline: none;\n  min-width: 200px;\n}\n\n.CanvasEditor-edit-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  color: #666;\n  transition: color 0.2s;\n  font-size: 16px;\n}\n\n.CanvasEditor-edit-button:hover {\n  color: #667eea;\n}\n\n.CanvasEditor-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.CanvasEditor-saving {\n  color: #999;\n  font-size: 0.9rem;\n}\n\n.CanvasEditor-save-button {\n  padding: 0.5rem 1rem;\n  background: #d8ff45;\n  color: #11120f;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n}\n\n.CanvasEditor-save-button:hover {\n  background: #e5ff80;\n}\n\n.CanvasEditor-save-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.CanvasEditor-share-button {\n  padding: 0.5rem;\n  background: transparent;\n  color: #94a3b8;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n}\n\n.CanvasEditor-share-button:hover {\n  background: rgba(148, 163, 184, 0.1);\n  color: #64748b;\n}\n\n.CanvasEditor-export-button {\n  padding: 0.5rem;\n  background: transparent;\n  color: #94a3b8;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  position: relative;\n}\n\n.CanvasEditor-export-button:hover {\n  background: rgba(148, 163, 184, 0.1);\n  color: #64748b;\n}\n\n.CanvasEditor-export-button:disabled {\n  cursor: not-allowed;\n  color: #cbd5f5;\n  background: rgba(148, 163, 184, 0.12);\n}\n\n.CanvasEditor-export-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(148, 163, 184, 0.4);\n  border-top-color: #64748b;\n  border-radius: 50%;\n  animation: CanvasEditor-spin 0.8s linear infinite;\n}\n\n.CanvasEditor-exporting {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.CanvasEditor-export-button:disabled .CanvasEditor-export-spinner {\n  border-top-color: #94a3b8;\n}\n\n.CanvasEditor-login-button {\n  padding: 0.5rem 1.5rem;\n  background: #d8ff45;\n  color: #11120f;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);\n}\n\n.CanvasEditor-login-button:hover {\n  background: #e5ff80;\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);\n  transform: translateY(-1px);\n}\n\n.CanvasEditor-canvas {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.CanvasEditor-loading,\n.CanvasEditor-error {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  gap: 1rem;\n}\n\n.CanvasEditor-error-message {\n  color: #e53e3e;\n  font-size: 1.2rem;\n}\n\n.CanvasEditor-error-button {\n  padding: 0.75rem 1.5rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.CanvasEditor-error-button:hover {\n  background: #5568d3;\n}\n\n/* 只读徽章 */\n.CanvasEditor-readonly-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: #fef3c7;\n  color: #92400e;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n/* 复制按钮 */\n.CanvasEditor-clone-button {\n  padding: 0.5rem 1rem;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.CanvasEditor-clone-button:hover {\n  background: #059669;\n}\n\n.CanvasEditor-clone-button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* 会员升级弹窗样式 */\n.CanvasEditor-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: CanvasEditor-fadeIn 0.2s ease-out;\n}\n\n.CanvasEditor-dialog {\n  background: white;\n  border-radius: 24px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.3);\n  max-width: 480px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: CanvasEditor-slideUp 0.3s ease-out;\n}\n\n.CanvasEditor-dialog-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 0.75rem 0;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.CanvasEditor-dialog-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  justify-content: center;\n}\n\n.CanvasEditor-dialog-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.75rem;\n  border: none;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.CanvasEditor-dialog-button:hover {\n  transform: translateY(-1px);\n}\n\n.CanvasEditor-dialog-button-cancel {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  color: #475569;\n}\n\n.CanvasEditor-dialog-button-cancel:hover {\n  background: rgba(241, 245, 249, 0.96);\n  border-color: rgba(99, 102, 241, 0.45);\n}\n\n.CanvasEditor-upgrade-overlay {\n  padding: 2rem;\n}\n\n.CanvasEditor-upgrade-dialog {\n  position: relative;\n  overflow: hidden;\n  max-width: 540px;\n  padding: 3rem 2.75rem 2.5rem;\n  text-align: center;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #ffffff 65%, rgba(245, 247, 250, 0.98) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.35);\n  animation: CanvasEditor-upgrade-pop 280ms ease-out;\n}\n\n.CanvasEditor-upgrade-dialog::before,\n.CanvasEditor-upgrade-dialog::after {\n  content: '';\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n  filter: blur(0px);\n}\n\n.CanvasEditor-upgrade-dialog::before {\n  width: 320px;\n  height: 320px;\n  background: radial-gradient(circle, rgba(254, 215, 170, 0.55) 0%, rgba(255, 255, 255, 0) 65%);\n  top: -140px;\n  right: -120px;\n}\n\n.CanvasEditor-upgrade-dialog::after {\n  width: 260px;\n  height: 260px;\n  background: radial-gradient(circle, rgba(127, 61, 255, 0.35) 0%, rgba(255, 255, 255, 0) 75%);\n  bottom: -110px;\n  left: -90px;\n}\n\n.CanvasEditor-upgrade-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  margin: 0 auto 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fed7aa 0%, #f97316 100%);\n  color: #9a3412;\n  box-shadow: 0 10px 40px rgba(249, 115, 22, 0.25);\n  position: relative;\n  z-index: 1;\n}\n\n.CanvasEditor-upgrade-icon svg {\n  width: 36px;\n  height: 36px;\n}\n\n.CanvasEditor-upgrade-title {\n  margin-bottom: 0.75rem;\n  position: relative;\n  z-index: 1;\n}\n\n.CanvasEditor-upgrade-message {\n  font-size: 1rem;\n  color: #3c4559;\n  line-height: 1.65;\n  margin: 0 auto 1.85rem auto;\n  max-width: 420px;\n  padding: 0.75rem 1rem;\n  background: rgba(236, 244, 255, 0.65);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 12px;\n  position: relative;\n  z-index: 1;\n}\n\n.CanvasEditor-upgrade-benefits {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.75rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  color: #2d3748;\n  font-size: 0.95rem;\n  position: relative;\n  z-index: 1;\n}\n\n.CanvasEditor-upgrade-benefits li {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  text-align: left;\n  padding: 0.65rem 0.9rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.65);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);\n}\n\n.CanvasEditor-upgrade-benefits li::before {\n  content: '';\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, #fcd34d 0%, #f97316 60%, #c026d3 100%);\n  flex-shrink: 0;\n}\n\n.CanvasEditor-upgrade-actions {\n  margin-top: 1rem;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n\n.CanvasEditor-upgrade-button {\n  background: linear-gradient(135deg, #7f3dff 0%, #d53f8c 100%);\n  color: #ffffff;\n  box-shadow: 0 10px 30px rgba(127, 61, 255, 0.35);\n  min-width: 150px;\n}\n\n.CanvasEditor-upgrade-button:hover {\n  background: linear-gradient(135deg, #6b2bd3 0%, #b83280 100%);\n  transform: translateY(-1px);\n}\n\n.CanvasEditor-upgrade-actions .CanvasEditor-dialog-button-cancel {\n  min-width: 120px;\n}\n\n/* 动画效果 */\n@keyframes CanvasEditor-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes CanvasEditor-slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes CanvasEditor-upgrade-pop {\n  0% {\n    opacity: 0;\n    transform: translateY(24px) scale(0.96);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes CanvasEditor-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .CanvasEditor-upgrade-overlay {\n    padding: 1.5rem;\n  }\n\n  .CanvasEditor-upgrade-dialog {\n    padding: 2.5rem 1.5rem 2rem;\n  }\n\n  .CanvasEditor-upgrade-message {\n    padding: 0.65rem 0.75rem;\n  }\n\n  .CanvasEditor-upgrade-benefits li {\n    padding: 0.55rem 0.75rem;\n  }\n}\n\n/* 公开项目提示弹窗 */\n.CanvasEditor-public-dialog {\n  max-width: 420px;\n  padding: 2rem 2rem 1.5rem;\n  text-align: center;\n}\n\n.CanvasEditor-public-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n  color: #1e40af;\n}\n\n.CanvasEditor-public-message {\n  font-size: 0.95rem;\n  color: #475569;\n  line-height: 1.6;\n  margin: 0 0 1.5rem 0;\n}\n\n.CanvasEditor-dialog-button-confirm {\n  background: #10b981;\n  color: white;\n}\n\n.CanvasEditor-dialog-button-confirm:hover {\n  background: #059669;\n}\n\n/* 图片转存提示弹窗 */\n.CanvasEditor-transfer-dialog {\n  max-width: 500px;\n  padding: 2rem 2rem 1.5rem;\n  text-align: center;\n}\n\n.CanvasEditor-transfer-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  color: #d97706;\n}\n\n.CanvasEditor-transfer-message {\n  font-size: 0.95rem;\n  color: #475569;\n  line-height: 1.6;\n  margin: 0 0 1.5rem 0;\n}\n\n.CanvasEditor-transfer-details {\n  margin: 1rem 0 1.5rem 0;\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  text-align: left;\n}\n\n.CanvasEditor-transfer-tip {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background: white;\n  border-left: 3px solid #f59e0b;\n  border-radius: 4px;\n}\n\n.CanvasEditor-transfer-list {\n  margin-top: 1rem;\n}\n\n.CanvasEditor-transfer-list-title {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #334155;\n  margin-bottom: 0.5rem;\n}\n\n.CanvasEditor-transfer-item {\n  font-size: 0.85rem;\n  color: #64748b;\n  padding: 0.5rem;\n  background: white;\n  border-radius: 4px;\n  margin-bottom: 0.25rem;\n}\n\n/* 帮助按钮样式 */\n.CanvasEditor-help-button {\n  padding: 0.5rem;\n  background: transparent;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  color: #667eea;\n}\n\n.CanvasEditor-help-button:hover {\n  background: #f0f4ff;\n  border-color: #667eea;\n  transform: translateY(-1px);\n}\n\n.CanvasEditor-help-button svg {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
